var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-split-to-do-list',{attrs:{"title":"Actielijst","toDos":_vm.toDos,"archive":""}})}
var staticRenderFns = []

export { render, staticRenderFns }